// extracted by mini-css-extract-plugin
export var activeDot = "_43-c";
export var buttonContainer = "_43-9";
export var channelButton = "_43-a";
export var clickable = "_43-d";
export var content = "_43-0";
export var contentFull = "_43-2";
export var contentThird = "_43-1";
export var contentWrapper = "_43-7";
export var description = "_43-5";
export var heightShort = "_43-f";
export var image = "_43-3";
export var imageContainer = "_43-4";
export var selectButton = "_43-e";
export var spinnerContainer = "_43-b";
export var titleContent = "_43-8";
export var titleWrapper = "_43-6";